<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabNewsletterMixin } from "../../modules/vodafone_lab_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, vodafoneLabNewsletterMixin],
  props: ["backgroundColor"]
};
</script>

<template>
  <div stripe-newsletter-content :style="{'background-color': backgroundColor}" class="w-100 py-5 text-white" v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="[contentType, {'bg-vodafone': !backgroundColor}]">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-9 col-lg-7">
          <h4 class="text-center mb-4">{{content.title}}</h4>
          <div class="w-100 mb-4 newsletter-description small text-center" v-html="content.description"></div>
          <newsletter-form :content="newsletterRecord" :opt-container-content="layoutContent" v-if="newsletterRecord"></newsletter-form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-newsletter-content] {
  min-height: 25rem;
}
</style>
